import React from "react";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import TableCell from "@mui/material/TableCell";
// import Checkbox from "@mui/material/Checkbox";
import TableRow from "@mui/material/TableRow";
import { Bank } from "../../../../../../../models";
import dayjs from "dayjs";




const BankListWidget: React.FC<{
  bank: Bank;
  active?: boolean;
  avatarBgColor?: string;
  onClickCheck?: (p: Bank) => void;
}> = ({
  bank,
  active = false,

  onClickCheck,
}) => {
  return (
    <TableRow>
      <TableCell component="th" scope="row">
        <Box display="flex" alignItems={"center"}>
          {/* <Box
            display="inline-block"
            sx={{
              mr: 1,
            }}
          >
            <Checkbox
              checked={active}
              onChange={() => {
                if (onClickCheck) {
                  onClickCheck(bank);
                }
              }}
            />
          </Box> */}

            <Typography component="span" fontSize="14px" fontWeight={"bold"}>
            {bank.BankName}
            </Typography>
        
        </Box>
      </TableCell>
  
      
      <TableCell align="right">{bank.BankCode}</TableCell>
      <TableCell align="right">
        
        {dayjs(bank.updatedAt).format("MMM D, YYYY")}

      </TableCell>
      <TableCell align="right">
        
        Paystack

      </TableCell>
    </TableRow>
  );
};

export default BankListWidget;
